import { render, staticRenderFns } from "./ArenaCardTimer.vue?vue&type=template&id=4cc9f042&"
import script from "./ArenaCardTimer.vue?vue&type=script&lang=js&"
export * from "./ArenaCardTimer.vue?vue&type=script&lang=js&"
import style0 from "./ArenaCardTimer.vue?vue&type=style&index=0&id=4cc9f042&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports